export default class PhoneMask {
  guide = true;
  showMask = true;
  mask = ['(',/\d/, /\d/, /\d/,')', /\d/, /\d/, /\d/, /\d/,'-', /\d/, /\d/, /\d/, /\d/];
}
